export const EXPANDABLE_FIELD_CODES = [
  'MODULE_ACTION',
  'PROJECT_ACTION',
  'FINAL_REPORT_PAYMENT'
];

export function isExpandableFieldCode(code) {
  return EXPANDABLE_FIELD_CODES.includes(code);
}
